import { useFetch } from "../../../hooks/api";
import { useMemo } from "react";
import Papa from "papaparse";
import { castNumbersInRowData } from "../utils/pathToPurchase/utils";
import { computeDerivedPlacementMetrics } from "../utils/placementMetrics";

const EXPORT_SUCCESS_STATUS = 2;

export const useAMCReportData = (
  reportId,
  queryType,
  includeData = true,
  parentId = null,
  enabled = true,
  options = {},
) => {
  const { subscription, pageSize } = options;

  const params = {
    export__status: EXPORT_SUCCESS_STATUS,
    ordering: "-created_on",
  };

  if (reportId) {
    params["id"] = reportId;
  }

  if (queryType) {
    params["query_type"] = queryType;
  }

  if (parentId) {
    params["parent"] = parentId;
  }

  if (subscription) {
    params["subscription"] = subscription;
  }

  if (!reportId) {
    params["page_size"] = pageSize || 100;
  }

  const { data: reportMetadata, isLoading: isReportDetailsLoading } = useFetch(
    ["amc_reports", reportId, queryType, parentId, subscription],
    reportId ? `/amc/reports/${reportId}` : "/amc/reports",
    params,
    {
      select: (res) => (reportId ? res.data : res.data.results),
      default: [],
      enabled: enabled,
    },
  );

  const exportReport = useMemo(() => {
    if (reportMetadata?.length === 1) {
      return reportMetadata[0]?.export;
    }
    return reportMetadata?.export;
  }, [reportMetadata]);

  const { data: csv, isLoading: isCSVDataLoading } = useFetch(
    ["export_downloads", exportReport?.id],
    `/api/exports/${exportReport?.id}/download/`,
    {},
    {
      enabled: !!exportReport && includeData,
      select: (res) => res.data,
    },
  );

  const data = useMemo(() => {
    if (!csv) return [];
    const { data } = Papa.parse(csv, {
      header: true,
      quoteChar: '"',
      escapeChar: "\\",
    });
    const result = data?.map((row) => castNumbersInRowData(row));

    const qt = reportMetadata?.query_type;
    if (qt?.includes("PLACEMENT_PERFORMANCE")) {
      for (const row of result) {
        computeDerivedPlacementMetrics(row);
      }
    }

    return result;
  }, [csv, reportMetadata]);

  if (includeData) {
    return { reportMetadata, data, isLoading: isReportDetailsLoading || isCSVDataLoading };
  }

  return { reportMetadata, isLoading: isReportDetailsLoading };
};
